import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import { useTranslation } from '../../../common/hooks/useTranslation';

export const UsersInRoleLink = (props: { roleId: string }) => {
  const nav = useNavigation();
  const { t, tk } = useTranslation('roleLng');

  return (
    <>
      <OverlayTrigger
        overlay={<Tooltip>{t(tk.employee.employeesAssigned)}</Tooltip>}
      >
        <Button
          onClick={() => nav.usersInRole(props.roleId)}
          variant="btn-info"
        >
          <Icon.PersonFill />
        </Button>
      </OverlayTrigger>
    </>
  );
};
